
import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { condoFlexibleDatePickerActions, CondoGuestInitialState, condoGuestsActions, condosLocationPickerActions, condoStrictDatesActions, DEFAULT_PERIOD, weeksDatesActions, weeksLocationsActions } from '@share/store/slices';
import { CondoEngines, CondoLocationsEnum, DateSearchTypeEnum, ICondoLocation, StayForEnum } from '@share/common-types';
import { ICondoUnitWeek } from '@common-types';
import { BlueButton } from '@share/components';
import { RootState } from '@share/utils';
import { Routes } from '@share/constants';

import { CondoWeeksDatesTable } from '../condo-week-dates-table';

import './style.scss';

const NOT_IMAGE_PROPERTY_URL = 'https://travcoding-hotel-resources.s3.us-east-1.amazonaws.com/not_image_property.jpg';

interface IProps {
  condo: ICondoUnitWeek;

  isWeeks: boolean;
  isAccount: boolean;
  isMarketing?: boolean;

  redirect: string;
}

export function CondoWeeksCard(props: IProps) {

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { condo, isWeeks, isAccount, redirect, isMarketing } = props;
  const { image } = condo;
  const { account } = loginStore;
  
  const dispatch = useDispatch();

  const handleOpen = () => {
    if (isAccount) {
      dispatch(condoGuestsActions.setState({ ...CondoGuestInitialState }));

      dispatch(condosLocationPickerActions.selectLocationLabel(condo?.locationName));
      dispatch(condosLocationPickerActions.selectLocation({
        id: condo?.locationId?.toString(),
        name: condo?.locationName,
      
        locationType: CondoLocationsEnum.GenericRegion,
        realType: CondoLocationsEnum.GenericRegion,

        engine: CondoEngines.CONDO 
      } as ICondoLocation));

      dispatch(condoFlexibleDatePickerActions.setState({ stayFor: StayForEnum.Week, selectedMonths: [] }));
      dispatch(condoStrictDatesActions.setSearchType(DateSearchTypeEnum.Flexible));

      setTimeout(() => window.open(`/${account?.name}${Routes.Condo}/${condo?.propertyId}${location.search}`, '_blank'), 500);
    } else {
      dispatch(weeksDatesActions.setDateSelected(moment(get(condo?.dates, '[0].checkIn', moment().format('yyyy-MM-DD')), 'yyyy-MM-DD').format('MM/DD/yyyy')));
      dispatch(weeksDatesActions.setPeriodSelected(DEFAULT_PERIOD));
      dispatch(weeksDatesActions.applyWeeksDates());

      dispatch(weeksLocationsActions.setSelectLocationLabel(condo?.locationName));
      dispatch(weeksLocationsActions.setSelectLocation({
        id: condo?.locationId?.toString(),
        name: condo?.locationName,
      
        locationType: CondoLocationsEnum.GenericRegion,
        realType: CondoLocationsEnum.GenericRegion,

        engine: CondoEngines.WEEKS 
      } as ICondoLocation));
      dispatch(weeksLocationsActions.applyLocation());

      setTimeout(() => window.open(`/${account?.name}${Routes.WeeksDetails}/${condo?.propertyId}${location.search}`, '_blank'), 500);
    }
  }

  const validImage = image && !isEmpty(image);
  const styleCard: any = { backgroundImage: `url(${validImage ? image : NOT_IMAGE_PROPERTY_URL})` };
  if (!validImage) {
    styleCard.backgroundBlendMode = 'luminosity';
  }

  const isGuestVendor = condo?.vendor === '01';
  if (isGuestVendor) {
    styleCard.border = `3px solid #822bf0`;
  }

  const renderBookButton = () => {
    if (isMarketing) {
      return null;
    }

    return (
      redirect ? (
        <div className="mt-2">
          <a className="btn btn-sm btn-success mb-0" style={{ cursor: 'pointer' }} href="https://getaways-club.com" target="_blank">Book</a>
        </div>) : (isWeeks || isAccount) ? (
          <div className="mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
            <BlueButton onClick={handleOpen}>Book</BlueButton>
          </div>) : null
    );
  };

  return (
    <div className="condo-weeks-card-wrapper">
      <div className="tns-item">
        <div className="card" style={styleCard}>

          {isGuestVendor ? (
            <div className="condo-hotel-card__label-recommended"><p className="condo-hotel-card__label-title"><FormattedMessage id="recommended.condo" /></p></div>) : null}

          {!validImage && (
            <div style={{ position: 'absolute', top: '0', right: '0', bottom: '0', left: '0', background: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <p className="condo-hotel-card__label-title" style={{ color: 'white', fontSize: '12px' }}>
                <FormattedMessage
                  id="not.real.image.property"
                  defaultMessage="Not actual photo of the property"
                />
              </p>
            </div>)}

          <div className="position-absolute top-100 start-50 translate-middle w-100" style={{ zIndex: 0 }}>
            <div className={`card-body text-center bg-mode shadow rounded mx-4 p-3${isMarketing ? ' marketing-card-body' : ''}`} style={{ display: 'flex', flexDirection: 'column' }}>
              <CondoWeeksDatesTable condo={condo} displayReduced />

              {renderBookButton()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
